import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { api, ApiError } from '../lib/api';

export function SessionDispatchPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ideaIdRaw = params.get('idea_id');
  const ideaCode = params.get('idea_code');
  const ideaId = ideaIdRaw ? Number(ideaIdRaw) : NaN;
  const body = ideaCode
    ? { idea_code: ideaCode }
    : Number.isInteger(ideaId) && ideaId > 0
      ? { idea_id: ideaId }
      : null;
  const valid = body !== null;

  const createMutation = useMutation({
    mutationFn: () => api.createSession(body!),
    onSuccess: (res) => {
      navigate(`/sessions/${res.session.id}`, { replace: true });
    },
  });

  useEffect(() => {
    if (valid && createMutation.status === 'idle') {
      createMutation.mutate();
    }
  }, [valid, createMutation]);

  if (!valid) {
    return (
      <div className="min-h-screen p-6 max-w-lg mx-auto flex flex-col items-center justify-center text-center">
        <h1 className="text-xl font-semibold mb-2">Не выбрана идея</h1>
        <button
          type="button"
          onClick={() => navigate('/ideas')}
          className="px-4 py-2 rounded-xl bg-tg-button text-tg-button-text"
        >
          К галерее идей
        </button>
      </div>
    );
  }

  if (createMutation.error) {
    const err = createMutation.error;
    const notFound = err instanceof ApiError && err.status === 404;
    return (
      <div className="min-h-screen p-6 max-w-lg mx-auto flex flex-col items-center justify-center text-center">
        <h1 className="text-xl font-semibold mb-2">
          {notFound ? 'Идея не найдена' : 'Не удалось открыть опросник'}
        </h1>
        <p className="text-sm opacity-70 mb-4">{err.message}</p>
        <button
          type="button"
          onClick={() => navigate('/ideas')}
          className="px-4 py-2 rounded-xl bg-tg-button text-tg-button-text"
        >
          К галерее идей
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-sm opacity-60">Загрузка...</p>
    </div>
  );
}
